import { FC } from 'react';
import { DataCategory } from './types';
import { SubheaderCategoryItemsDesktop } from '../subheader-category-items-desktop';
import { SubheaderCategoryItemsMobile } from '../subheader-category-items-mobile';
import { SubheaderMobileBuyingOptions } from '../subheader-category-items-mobile/subheader-mobile-buying-options';
interface CategoryItems {
  categoriesLabel: string;
  categories: DataCategory[]
  buyingOptionsLabel: string;
  buyingOptions: DataCategory[]
  isMobile?: boolean;
}

export const SubheaderCategoryItems: FC<CategoryItems> = ({
  categories,
  categoriesLabel,
  buyingOptionsLabel,
  buyingOptions,
  isMobile = false,
}) => {

  return isMobile ? (
    <SubheaderCategoryItemsMobile
      categories={categories}
    >
      <SubheaderMobileBuyingOptions
        label={buyingOptionsLabel}
        buyingOptions={buyingOptions}
      />
    </SubheaderCategoryItemsMobile>
  ) : (
    <>
      <SubheaderCategoryItemsDesktop
        label={categoriesLabel}
        categories={categories}
        divider
      />
      <SubheaderCategoryItemsDesktop
        label={buyingOptionsLabel}
        categories={buyingOptions}
      />
    </>
  );
};
